import User from '@/store/models/user/user';
import UserProfileResponse from '@/store/models/user/user_profile_response';
import UserIslandProgressionListResponse from '@/store/models/user/user_island_progression_list_response';
import UserIslandProgressionItemResponse from '@/store/models/user/user_island_progression_item_response';
import CountryResponse from '@/store/models/user/country_response';
import NotificationResponse from '@/store/models/user/notification_response';
import IslandNotificationResponse from '@/store/models/user/island_notification_response';
import CouponCodeResponse from '@/store/models/user/coupon_code_response.js';
import CeoMessagesResponse from '@/store/models/user/ceo_messages_response';
import PushNotification from '@/store/models/user/push_notification';
import AbInfo from '@/store/models/user/ab_info';
import eventBus from '@/components/shared/eventbus';

import { fetchData, apiURL } from './api_helper';

const redeemCoupon = (apiLevel, coupon_code) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/redeem_coupon/`;
    fetchData(endpointURL, 'post', { coupon_code })
      .then((result) => {
        const mappedCoupon = new CouponCodeResponse();
        mappedCoupon.map(result.response);
        resolve(mappedCoupon);
      })
      .catch((error) => {
        reject(error);
      });
  });

const authWithDKTSSO = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/idp_authentication`;
    fetchData(endpointURL, 'post', data, false)
      .then((result) => {
        const mappedUser = new User();
        mappedUser.map(result.response);
        resolve(mappedUser);
      })
      .catch((error) => {
        reject(error);
      });
  });

const authZeroPassword = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/initiate_zero_password_authentication`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const authKHPoll = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/poll_zero_password_authentication`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        const error = result.response.errors;
        if (error && result.response.errors.length > 0) {
          resolve(result);
        } else {
          const mappedUser = new User();
          mappedUser.map(result.response);
          resolve(mappedUser);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

  const neptunAuthZeroPassword = (apiLevel, data) =>
    new Promise((resolve, reject) => {
      const endpointURL = `${apiURL}${apiLevel}/users/initiate_zero_password_authentication_neptun`;
      fetchData(endpointURL, 'post', data)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });

const loginUser = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/login`;
    const credentials =
      data.credentials === undefined ? data : data.credentials;
    const authTokenRequired =
      data.authTokenRequired == undefined ? undefined : data.authTokenRequired;
    if (!credentials.provider) {
      throw new Error('(LOG) Login failure, provider missing');
    }
    if (credentials.provider === 'google' && (credentials.access_token === '' || !credentials.access_token)) {
      throw new Error('(LOG) Login failure, google access token is missing');
    }
    fetchData(endpointURL, 'post', credentials, authTokenRequired)
      .then((result) => {
        const mappedUser = new User();
        mappedUser.map(result.response);
        resolve(mappedUser);
      })
      .catch((error) => {
        reject(error);
      });
  });

const profileUpdate = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/profile`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchUserProfile = (apiLevel, league, inviterCode) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${apiLevel}/users/profile?league=${league}`;

    if (inviterCode !== undefined) {
      endpointURL = `${endpointURL}&inviter_code=${inviterCode}`;
    }

    fetchData(endpointURL, 'get')
      .then((result) => {
        if (
          result &&
          result.response &&
          result.response.errors &&
          result.response.errors.length > 0
        ) {
          if (result.response.errors[0].code == 400) {
            return reject(result.response.errors[0]);
          }
        }
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUserProfile = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/profile`;
    fetchData(endpointURL, 'get', payload)
      .then((result) => {
        if (
          result &&
          result.response &&
          result.response.errors &&
          result.response.errors.length > 0
        ) {
          if (result.response.errors[0].code == 400) {
            return reject(result.response.errors[0]);
          }
        }
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updatePushNotificationSetup = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/push_notification_do_disturb`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        const pushNotification = new PushNotification();
        pushNotification.map(result.response);
        resolve(pushNotification);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getPushNotificationSetup = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/push_notification_do_disturb`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const pushNotification = new PushNotification();
        pushNotification.map(result.response);
        resolve(pushNotification);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchIslandProgressionList = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/island_progression_list`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const res = result.response;
        const certifications = [];
        res.forEach((item) => {
          const userIslandProgressionListResponse = new UserIslandProgressionListResponse();
          userIslandProgressionListResponse.map(item);
          certifications.push(userIslandProgressionListResponse);
        });
        resolve(certifications);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchIslandProgressionItem = (apiLevel, level) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/island_progression_item?level=${level}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const userIslandProgressionItemResponse = new UserIslandProgressionItemResponse();
        userIslandProgressionItemResponse.map(result.response);
        resolve(userIslandProgressionItemResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchUserCountry = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/country_check`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const countryResponse = new CountryResponse();
        countryResponse.map(result.response);
        resolve(countryResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const setAvatar = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/set_avatar`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const addAsFriend = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/followers/${payload}`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchUserProfileNotifications = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    let endpointURL = '';
    if (payload.friends) {
      endpointURL = `${apiURL}${apiLevel}/users/profile_notifications?friends=true&page=${payload.page}`;
    } else {
      endpointURL = `${apiURL}${apiLevel}/users/profile_notifications?page=${payload.page}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        const notificationResponse = new NotificationResponse();
        notificationResponse.map(result.response);
        resolve(notificationResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchArchivedLeagues = (apiLevel, page, leagueCode = undefined) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${apiLevel}/users/previous_champions?page=${page}`;
    if (leagueCode) {
      endpointURL = `${endpointURL}&league_code=${leagueCode}`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        // TODO: no model mapping
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchFriendProfile = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/${payload}/profile`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchFriendListByType = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    let endpointURL = '';
    if (payload === 'facebook') {
      endpointURL = `${apiURL}${apiLevel}/users/friend_list/facebook_contacts`;
    } else if (payload === 'google') {
      endpointURL = `${apiURL}${apiLevel}/users/friend_list/google_contacts`;
    } else {
      endpointURL = `${apiURL}${apiLevel}/users/friend_list/maybe_know`;
    }
    fetchData(endpointURL, 'get')
      .then((result) => {
        // TODO: no model mapping
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchMaybeUnknownList = (apiLevel, userIds) =>
  new Promise((resolve, reject) => {
    let endpointURL = `${apiURL}${apiLevel}/users/friend_list/maybe_know?`;
    userIds.forEach((element, index) => {
      if (userIds[index + 1]) {
        endpointURL = endpointURL.concat(`user_id_list[]=${element}&`);
      } else {
        endpointURL = endpointURL.concat(`user_id_list[]=${element}`);
      }
    });
    fetchData(endpointURL, 'get')
      .then((result) => {
        // TODO: no model mapping
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const profileDestroy = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/destroy`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const unSubscribe = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/invitation/unsubscribe?locale=${payload.locale}&invited_user_id=${payload.invited_user_id}&invited_contact_id=${payload.invited_contact_id}&persistent=${payload.persistent}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        // TODO: no model mapping
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const storeUserAction = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/user_action`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        const userActionResponse = new User();
        userActionResponse.map(result.response);
        resolve(userActionResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchIslandNotification = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/notification`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const islandNotification = new IslandNotificationResponse();
        islandNotification.map(result.response);
        resolve(islandNotification);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchCeoMessage = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/ceo_messages`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const res = result.response;
        const ceoMessages = [];
        res.forEach((item) => {
          const ceoMessageResponse = new CeoMessagesResponse();
          ceoMessageResponse.map(item);
          ceoMessages.push(ceoMessageResponse);
        });
        resolve(ceoMessages);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateCeoMessageStatus = (apiLevel, messageId) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/notification/${messageId}/make_read`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getUserInfoByInvitationCode = (apiLevel, invitationCode) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/user_info_by_invitation_code?invitation_code=${invitationCode}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const uploadContacts = (apiLevel, params) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/upload_contacts?invite=${params.invite}&invite_all=${params.inviteAll}`;
    fetchData(endpointURL, 'post', { contacts: params.contacts })
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchGoogleContacts = (apiLevel, authCode) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/fetch_google_contacts`;
    fetchData(endpointURL, 'post', { auth_code: authCode })
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const storeWebPushInfo = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/store_web_push_info`;
    fetchData(endpointURL, 'post', data)
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const changedPushNotificationStatus = (apiLevel, data) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/notification_status_change/${data.notificationId}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result.response);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateClassroomName = (apiLevel, body) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/profile`;
    fetchData(endpointURL, 'post', body)
      .then((result) => {
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const syncTimer = (apiLevel, body) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/sync_timer`;
    fetchData(endpointURL, 'post', body)
      .then((result) => {
        const abInfo = new AbInfo();
        abInfo.map(result.response);
        resolve(abInfo);
      })
      .catch((error) => {
        reject(error);
      });
  });

const logoutUser = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/logout`;
    fetchData(endpointURL, 'post', {})
      .then((result) => {
        const abInfo = new AbInfo();
        abInfo.map(result.response);
        resolve(abInfo);
      })
      .catch((error) => {
        reject(error);
      });
  });

const keepSignInUser = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/keep_sign_in`;
    fetchData(endpointURL, 'post', {})
      .then((result) => {
        const abInfo = new AbInfo();
        abInfo.map(result.response);
        resolve(abInfo);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateEmailForSubscription = (apiLevel, requestBody) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/update_email_for_subscription`;
    fetchData(endpointURL, 'post', requestBody)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getAllFriends = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/all_friends`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  loginUser,
  authWithDKTSSO,
  profileUpdate,
  fetchUserProfile,
  getUserProfile,
  fetchIslandProgressionList,
  fetchIslandProgressionItem,
  fetchUserCountry,
  setAvatar,
  fetchArchivedLeagues,
  fetchUserProfileNotifications,
  fetchFriendListByType,
  fetchFriendProfile,
  addAsFriend,
  profileDestroy,
  unSubscribe,
  storeUserAction,
  fetchIslandNotification,
  getUserInfoByInvitationCode,
  uploadContacts,
  fetchGoogleContacts,
  redeemCoupon,
  getPushNotificationSetup,
  updatePushNotificationSetup,
  storeWebPushInfo,
  fetchCeoMessage,
  updateCeoMessageStatus,
  changedPushNotificationStatus,
  fetchMaybeUnknownList,
  updateClassroomName,
  syncTimer,
  logoutUser,
  keepSignInUser,
  updateEmailForSubscription,
  getAllFriends,
  authZeroPassword,
  authKHPoll,
  neptunAuthZeroPassword,
};
